import tonStyles from './../ton.json'

export default {
  weight: 'bold',
  color: tonStyles.colors.PrimaryBlack,
  inverseColor: tonStyles.colors.PrimaryWhite
}
